import { computeReadingRhythm, type RhythmMode } from '../cinematic/adaptive/useReadingRhythm';

interface ReadingRevealCompleteInput {
  message: string;
  mode: RhythmMode;
  pacing: number;
  startDelay?: number;
}

/**
 * End the reveal when the final animated text chunk has appeared — not after a
 * separate reading dwell. Attached memories should continue immediately.
 */
export function getReadingRevealCompleteMs({
  message,
  mode,
  pacing,
  startDelay = 0,
}: ReadingRevealCompleteInput): number {
  const rhythm = computeReadingRhythm({ message, mode, pacing, startDelay });
  const finalChunk = rhythm.chunks[rhythm.chunks.length - 1];
  const finalWordVisibleSeconds = finalChunk
    ? finalChunk.delay + finalChunk.duration
    : rhythm.totalDuration;
  return Math.round((finalWordVisibleSeconds + 0.35) * 1000);
}
